import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { DETAILS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useDetailsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useDetailsBidOnAgent() {
  const { startListen } = useWebSocketStore()
  const { sessionData, isAuthed } = useAutobidAuth()
  const { updateDetailsCarData } = useUpdateCar()

  const bidOnAgent = () => {
    startListen({
      eventName: 'premium.USER_BID_ON_AGENT',
      callbackName: DETAILS_SOCKET_CALLBACK,
      callback: (event) => {
        if (!isAuthed.value)
          return

        const { carId, userId } = event.context

        updateDetailsCarData(carId, (item) => {
          const amIBidder = sessionData.value?.user?.id === userId

          return {
            ...item,
            hasBid: amIBidder ? true : item.hasBid,
            isHighestBidder: amIBidder,
          }
        })
      },
    })
  }

  return { bidOnAgent }
}
